export const HIERARCHY_WARNING = `Please note: Customer level drafting instructions will always override user level instructions.`;
export const AUTO_REPLY_HELPER_TEXT = `Tell Vooma how you would like to respond. You can describe your ideal response format, provide a template, or give an example.`;
